import {EventEmitter} from 'events';
export const FlowEvents = new EventEmitter();

export const RESET_AREA = "RESET_AREA";
export const DETERMINE_AREA = "DETERMINE_AREA";
export const END_AREA = "END_AREA";
